import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronLightRegularDownIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 32 32",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M15.2 23.7q.8.6 1.7 0l10-10q.6-1 0-1.7-1-.7-1.7 0L16 21 7 12q-1-.7-1.7 0-.8.8 0 1.7z" })
});
export default SvgChevronLightRegularDownIcon;
